import React from "react";
import ReactDOM from "react-dom";

import App from "App";

import "./assets/SCSS/styles.scss";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
